import { format } from 'date-fns';
import { usePeriodClosureContext } from '@/context/PeriodClosureContext';
import { cn } from '@/lib/utils';

interface PeriodClosureNoticeProps {
  className?: string;
}

const PeriodClosureNotice = ({ className }: PeriodClosureNoticeProps) => {
  const { getClosedDate } = usePeriodClosureContext();
  const closedDate = getClosedDate();

  if (!closedDate) return null;

  return (
    <div
      className={cn('mb-4 p-3 bg-amber-50 border border-amber-200 rounded-md', className)}
      role="status"
      aria-live="polite"
    >
      <p className="text-sm text-amber-800">
        ⚠️ Período cerrado hasta el <strong>{format(closedDate, 'dd/MM/yyyy')}</strong>. No puede
        seleccionar una fecha contable igual o anterior.
      </p>
    </div>
  );
};

export default PeriodClosureNotice;
